<template>
  <main id="main-container">
    <div class="row no-gutters bg-primary-op">
      <div class="hero-static col-md-6 d-flex align-items-center bg-white">
        <div class="p-3 w-100">
          <div class="mb-3 text-center">
            <a class="link-fx font-w700 font-size-h1" href="/"> </a>
          </div>
          <div class="row no-gutters justify-content-center">
            <div class="col-sm-8 col-xl-6">
              <div class="alert alert-danger" role="alert" v-if="error">
                <p class="mb-0" v-html="error"></p>
              </div>
              <div class="mb-12 text-center">
                <a
                  class="link-fx text-warning font-w700 font-size-h1"
                  href="index.html"
                >
                  <span class="text-dark">ARX</span>
                </a>
                <p class="text-uppercase font-w700 font-size-sm text-muted">
                  Password Reminder
                </p>
              </div>
              <form
                class="js-validation-reminder"
                action="Signln.vue"
                method="POST"
              >
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control form-control-alt"
                    id="reminder-credential"
                    name="reminder-credential"
                    placeholder="Email"
                  />
                </div>
                <div class="form-group text-center">
                  <button
                    type="submit"
                    class="btn btn-block btn-hero-primary"
                    @click="$router.push('/sign-in')"
                  >
                    <i class="fa fa-fw fa-reply mr-1"></i> Reset Password
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div
        class="hero-static col-md-6 d-none d-md-flex align-items-md-center justify-content-md-center text-md-center"
      >
        <div class="p-3">
          <p class="display-4 font-w700 text-white mb-3">klik met je klant</p>
          <p class="font-size-lg font-w600 text-white-75 mb-0">
            Copyright &copy;
            <span data-toggle="year-copy"></span>
          </p>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
// import SidebarComponent from "../components/layout/Sidebar";
import { mapActions, mapState } from "vuex";

export default {
  name: "UsersEdit",

  components: {
    // SidebarComponent,
  },
  data: () => {
    return {
      userForUpdate: {
        id: null,
        name: "",
        email: "",
        password: ""
      }
    };
  },
  created() {
    this.getUserById(this.$route.params.id).then(res => {
      this.userForUpdate.id = res.data.data.id;
      this.userForUpdate.name = res.data.data.name;
      this.userForUpdate.email = res.data.data.email;
    });
  },
  methods: {
    ...mapActions({
      getUserById: "users/getUserById",
      updateUserById: "users/updateUserById"
    }),
    handleNameForUpdate(e) {
      this.userForUpdate.name = e.target.value;
    },
    handleEmailForUpdate(e) {
      this.userForUpdate.email = e.target.value;
    },
    handlePasswordForUpdate(e) {
      this.userForUpdate.password = e.target.value;
    },
    saveUser(e) {
      e.preventDefault();
      if (
        this.userForUpdate.name !== "" &&
        this.userForUpdate.email !== "" &&
        this.userForUpdate.password !== ""
      ) {
        this.updateUserById(this.userForUpdate);
      } else {
        alert("Please fill in the blank fields!!!");
      }
    }
  },
  computed: {
    ...mapState({
      user: state => state.users.User
    })
  }
};
</script>
